var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-confirmation" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-center flex-column align-items-center py-4"
      },
      [
        _c("img", {
          staticClass: "mb-4",
          attrs: {
            width: "170",
            height: "170",
            src: require("@/assets/icon/confirmation.svg"),
            alt: "icon popup confirmation"
          }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "title" }, [_vm._v("Confirmation")]),
        _vm._v(" "),
        _c("p", {
          staticClass: "message",
          domProps: { innerHTML: _vm._s(_vm.message) }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "w-full d-flex justify-content-center" }, [
          _c(
            "button",
            {
              staticClass: "button-border-blue mr-4",
              on: {
                click: function($event) {
                  _vm.$emit("close")
                }
              }
            },
            [_vm._v("\n        Cancel\n      ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button-blue",
              on: {
                click: function($event) {
                  _vm.$emit("confirm")
                }
              }
            },
            [_vm._v("\n        Yes\n      ")]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-588d690a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-588d690a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/jPopupConfirmation.vue
// module id = null
// module chunks = 